import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';

const ExamResults = () => {
  const { id } = useParams();
  const { SetNotification } = useStateContext();
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLeaderboard = async () => {
    try {
      const response = await AxiosClient.get(`/sessions/${id}/exams/leaderboard`);
      const payload = response.data?.leaderboard ?? response.data ?? [];
      const normalized = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : [];
      setLeaderboard(normalized);
    } catch (error) {
      SetNotification('Error loading leaderboard', 'danger');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
    const intervalId = setInterval(() => {
      fetchLeaderboard();
    }, 5000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) return <h6 className="m-3">Loading leaderboard...</h6>;

  return (
    <div className="m-4">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
        <div>
          <h3 className="mb-1">Exam leaderboard</h3>
          <small className="text-muted">Ranked by score and fastest completion time.</small>
        </div>
        <Link to={`/sessions/${id}/exam`} className="btn btn-outline-dark">Back to exam</Link>
      </div>

      <div className="card p-3">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
          <div>
            <h5 className="mb-0">Live results</h5>
            <small className="text-muted">Updated automatically every 5 seconds.</small>
          </div>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={fetchLeaderboard}>Refresh now</button>
        </div>

        {!leaderboard.length ? (
          <div className="alert alert-light border mb-0">
            <strong>No completed attempts yet.</strong>
            <div className="text-muted mt-1">The leaderboard will appear after the participants finish the exam.</div>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table align-middle mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Participant</th>
                  <th>Correct</th>
                  <th>Total</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.map((entry) => (
                  <tr key={entry.id}>
                    <td>{entry.rank}</td>
                    <td className="fw-bold">{entry.participant_name}</td>
                    <td>{entry.correct_answers}</td>
                    <td>{entry.total_questions}</td>
                    <td>{entry.elapsed_seconds}s</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExamResults;
